import comp from "./WithRecorder";
export default comp;
